import type { Dictionary } from './en';

/**
 * French translation — baseline for shipping; should be reviewed by a
 * native FR speaker before production. See i18n/CHECKLIST.md.
 */
const fr: Dictionary = {
  brand: 'ArriveSafe',
  meta: {
    titleDefault: 'ArriveSafe',
    titleTravelling: 'ArriveSafe – Suivez {name} en route',
    titleArrived: 'ArriveSafe – {name} est bien arrivé',
    titleEmergency: 'ArriveSafe – {name} a déclenché une urgence',
  },
  social: {
    titleDefault: 'Je partage ma position',
    descriptionDefault: "Suivez-moi jusqu'à mon arrivée.",
    titleTravelling: '{name} est en route',
    descriptionTravelling: "Suivez {name} en direct jusqu'à son arrivée.",
    titleArrived: '{name} est bien arrivé',
    descriptionArrived: 'Le trajet est terminé.',
  },
  status: {
    onTheWay: '{name} est en route',
    onTheWayTo: '{name} est en route vers {destination}',
    arrived: '{name} est bien arrivé à {time}',
    arrivedNoTime: '{name} est bien arrivé',
    emergency: '{name} a déclenché une urgence',
    titleSubtitle: '{name} est en route',
  },
  transport: {
    foot: 'à pied',
    running: 'en courant',
    bike: 'à vélo',
    car: 'en voiture',
    motorcycle: 'à moto',
    bus: 'en bus',
    train: 'en train',
    plane: 'en avion',
    boat: 'en bateau',
    horse: 'à cheval',
    detecting: 'détection…',
  },
  connection: {
    connecting: 'Connexion',
    live: 'En direct',
    stale: 'Signal faible',
    offline: 'Hors ligne',
  },
  stats: {
    battery: 'Batterie',
    speed: 'Vitesse',
    avgSpeed: 'Vitesse moy.',
    distance: 'Distance',
    time: 'Heure',
    startAddress: 'Départ',
    finishAddress: 'Arrivée',
    lastUpdate: 'Mis à jour il y a {seconds} s',
    lastUpdateMin: 'Mis à jour il y a {minutes} min',
    justUpdated: 'À l’instant',
  },
  welcome: {
    prompt: '{name} t’a invité·e comme accompagnant·e.',
    askName: 'Sous quel prénom veux-tu apparaître ?',
    nameLabel: 'Ton prénom',
    save: 'Enregistrer le prénom',
    skip: 'Passer',
    watchingAs: 'Tu suis en tant que {name}',
    setYourName: 'Renseigner ton prénom',
  },
  download: {
    title: 'Télécharger ArriveSafe',
    blurb: 'Partage tes propres trajets avec tes proches.',
    ios: 'App Store',
    android: 'Google Play',
    chip: 'Obtenir l’app',
    chipDismiss: 'Fermer',
    iosCta: 'Télécharger sur l’App Store',
    androidCta: 'Télécharger sur Google Play',
    otherCta: 'Télécharger ArriveSafe',
  },
  loading: {
    title: 'Chargement du trajet…',
    verifying: 'Vérification du code…',
    fetching: 'Chargement de la route…',
  },
  empty: {
    notFound: 'Ce trajet est introuvable.',
    noCode: 'Ouvre cette page avec un code de partage : {url}',
    error: 'Une erreur est survenue : {message}',
  },
  playback: {
    play: 'Rejouer le chemin',
    playing: 'Lecture en cours…',
    pause: 'Pause',
    resume: 'Reprendre',
    replay: 'Rejouer le chemin',
    pausedAt: 'En pause à {time}',
  },
  timeline: {
    title: 'Journal du trajet',
    close: 'Fermer',
    routeStarted: 'Trajet commencé',
    batteryDrop: 'Batterie à {battery}%',
    stationary: 'À l’arrêt depuis {duration}',
    stillEnRoute: 'Toujours en route',
    stillEnRouteProgress: 'Toujours en route · {progress}%',
    arrived: 'Arrivé',
    emergency: 'Urgence déclenchée',
    emergencyAlerted: 'Urgence déclenchée · {count} contacts alertés',
    companionJoined: '{name} accompagne le trajet',
    companionJoinedUnnamed: 'Un·e accompagnant·e a rejoint',
  },
  emergency: {
    bannerActive: '{name} a déclenché une urgence',
    bannerCleared: '{name} s’est signalé en sécurité à {time}',
    triggeredAgo: 'il y a {relative}',
    lastKnown: 'Dernière position connue',
    callServices: 'Appeler les secours ({number})',
    copyLocation: 'Copier la position',
    openInMaps: 'Ouvrir dans Maps',
    enableAlerts: 'Touche pour activer les alertes sonores',
    wrongCountry: 'Mauvais pays ? Changer',
  },
  ariaLive: {
    travelling: '{name} est en route.',
    arrived: '{name} est bien arrivé.',
    emergency: '{name} a déclenché une urgence. Dernière position connue : {location}.',
  },
};

export default fr;
